'use strict';

angular.module('buyers')
.directive("ajaxMultiSelect", ['$rootScope', '$q', '$http', 'CommonService', function($rootScope, $q, $http, CommonService) {
  return {
    restrict : "E",
    templateUrl : "partials/ajaxMultiSelect.html",
    scope: {
      'apiPath': '=',
      'apiParam': '=',
      'apiSearchField': '=',
      'selectedOptions': '=',
      'searchTextMinLen': '='
    },
    link : function(scope, el, attrs) {
        scope.ajaxMultiSelectOptions = [];
        scope.showOptions = false;
        scope.loadingOptions = false;

        scope.$watch('selectedOptions', function(){
          var searchText = '';
          var arrSearchText = [];
          angular.forEach(scope.selectedOptions, function(option) {
            var searchText = option.name.toUpperCase().trim();
            if (arrSearchText.indexOf(searchText) < 0) {
              arrSearchText.push(searchText);  
            }
          });
          searchText = arrSearchText.join(', ') + ((arrSearchText.length>0) ? ', ' : '');
          el.find("#ajaxMulitSelectSearchText").val(searchText);
        });

        var getOptions = function(searchText) {
            scope.apiParam[scope.apiSearchField] = searchText;
            var dfd = $q.defer();
            $http({
                url: scope.apiPath
                ,method: "GET"
                ,params: scope.apiParam
            }).success(function(data, status, headers, config) {
                dfd.resolve(data);
            }).error(function(data, status, headers, config) {
                dfd.reject("Error: request returned status " + status); 
            });
            return dfd.promise;
        }

        $(document).on('click', function(){
          var optionsEntered = '';
          var searchTextVal = el.find("#ajaxMulitSelectSearchText").val();
          var arrOptionEntered = searchTextVal.split(',');
          optionsEntered = addToSelectedOptions(arrOptionEntered);
          // el.find('.ajax-multi-select-search-text').val(optionsEntered);
          scope.$apply(function(){
            scope.showOptions = false;     
          })
          
        });

        el.find("#ajaxMulitSelectSearchText").on('keyup',function(e) {
            var escapeChars = [37, 38, 39, 40, 13, 32];
           
            if(scope.loadingOptions || escapeChars.indexOf(e.which) > -1 ) {
                return;
            }
            var searchTextVal = el.find("#ajaxMulitSelectSearchText").val();

console.log(searchTextVal);

            var arrValidSearchText = [];
            var searchText = $(this).val();
            arrSearchText = searchText.split(',');

            //check for valid search text
            for(var i=0; i < arrSearchText.length; i++) {
              if (arrSearchText[i].trim().length > scope.searchTextMinLen) {
                 arrValidSearchText.push(arrSearchText[i].trim());
              }
            }

            if (arrValidSearchText.length) {
              scope.loadingOptions = true;
              getOptions(arrValidSearchText.join(','))
              .then(function(data){
                if(data.length>0) {
                  scope.ajaxMultiSelectOptions = data;
                  scope.showOptions = true;   
                } else {
                  scope.ajaxMultiSelectOptions = [];
                  scope.showOptions = false;   
                }
              })
              .catch(function(err){
                scope.ajaxMultiSelectOptions = [];
                scope.loadingOptions = false;
              })
              .finally(function(data){
                scope.loadingOptions = false;
              });
            } else {
               scope.ajaxMultiSelectOptions = [];
               scope.showOptions = false;   
            }
        });

        var addToSelectedOptions = function(arrOptionEntered) {
          var arrOptionEnteredSelected = arrOptionEntered;

          if(scope.ajaxMultiSelectOptions.length) {

            arrOptionEnteredSelected = [];
            scope.selectedOptions = [];

            angular.forEach(arrOptionEntered, function(optionEntered) {
              optionEntered = optionEntered.toUpperCase().trim();
              if(optionEntered.length > scope.searchTextMinLen && arrOptionEnteredSelected.indexOf(optionEntered) < 0 ) {
                for (var i=0; i<scope.ajaxMultiSelectOptions.length; i++) {
                  var option = scope.ajaxMultiSelectOptions[i];
                  var strOption = option.name.toUpperCase().trim();
                  if (strOption == optionEntered) {
                    scope.selectedOptions.push(option);
                    arrOptionEnteredSelected.push(optionEntered);
                    break;
                  }
                }
              } 
            });
          }
          if(arrOptionEnteredSelected.length == 0) {
            scope.selectedOptions = [];
          }
          return arrOptionEnteredSelected.join(',');
        }

        scope.selectOption = function(option) {
          var optionsEntered = '';
          var searchTextVal = el.find("#ajaxMulitSelectSearchText").val();
          var arrOptionEntered = searchTextVal.split(',');
          arrOptionEntered.push(option.name);
          optionsEntered = addToSelectedOptions(arrOptionEntered);
          // el.find('.ajax-multi-select-search-text').val(optionsEntered);
          scope.showOptions = false;
        }

        // scope.removeOption = function(option) {
        //   var index = scope.selectedOptions.indexOf(option);
        //   if(index > -1) {
        //     scope.selectedOptions.splice(index, 1);            
        //   }
        // }
        // 
        // 
        
        
    }
  };
}]);